import { render, staticRenderFns } from "./TaskCreateIndividual.vue?vue&type=template&id=27a66266"
import script from "./TaskCreateIndividual.vue?vue&type=script&lang=ts"
export * from "./TaskCreateIndividual.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports